import { Item } from 'components/CollabItem/Item'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { ReactControlProps } from './Types'
import { ReactionPicker } from 'components/ReactionPicker/ReactionPicker'
import { IconButton } from 'components/IconButton/IconButton'
import ItemStyles from 'components/CollabItem/CollabItem.module.scss'

const ReactControl = observer(({ comment }: ReactControlProps) => {
  const rootStore = useRootStore()

  const handleSelectReaction = (emoji: string) => {
    rootStore.comments.toggleReaction(comment.id, emoji)
  }

  return (
    <Item.Control tooltipTitle="Add reaction" tooltipPlacement="bottom">
      <ReactionPicker onSelect={handleSelectReaction}>
        <IconButton
          className={ItemStyles.controlItem}
          size="sm"
          onPress={() => handleSelectReaction('👍')}
          data-title="Add reaction"
        >
          👍
        </IconButton>
      </ReactionPicker>
    </Item.Control>
  )
})

export { ReactControl }
